var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownolad1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4948 2.35815H4.99479C4.55276 2.35815 4.12884 2.53375 3.81628 2.84631C3.50372 3.15887 3.32813 3.58279 3.32812 4.02482V17.3582C3.32813 17.8002 3.50372 18.2241 3.81628 18.5367C4.12884 18.8492 4.55276 19.0248 4.99479 19.0248H14.9948C15.4368 19.0248 15.8607 18.8492 16.1733 18.5367C16.4859 18.2241 16.6615 17.8002 16.6615 17.3582V6.52482L12.4948 2.35815Z",
    stroke: "#00ADF0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 2.35815V5.69149C11.6641 6.13352 11.8397 6.55744 12.1522 6.87C12.4648 7.18256 12.8887 7.35815 13.3307 7.35815H16.6641",
    stroke: "#00ADF0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.6914V10.6914",
    stroke: "#00ADF0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.1914L10 15.6914L12.5 13.1914",
    stroke: "#00ADF0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownolad1);
export default __webpack_public_path__ + "static/media/downolad1.5923b8c9c9b37e85ea2fe4439cdb6135.svg";
export { ForwardRef as ReactComponent };